/**
 * Ayuda — Administración → Terminal de Ventas
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
const ADM_SALES_TERMINAL_POS_ITEM = {
  id: 'terminal',
  screenId: 'adm-sales-terminal-pos',
  label: 'Pantalla de venta',
  description: 'Vendé rápido desde el mostrador.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'La terminal de ventas es una pantalla simplificada para cobrar en el mostrador: buscás productos, aplicás promociones y registrás el cobro en pocos pasos.',
      },
      {
        title: 'Paso 1 — Entrar',
        bullets: [
          'Si tenés más de una terminal asignada, elegís cuál usar.',
          'Si falta configuración (lista de precios, tipos de comprobante, etc.), el sistema avisa; contactá al administrador.',
        ],
      },
      {
        title: 'Paso 2 — Encabezado',
        fields: [
          { label: 'Comprobante', description: 'Tipo de factura a emitir (A, B, C, etc.). Si es electrónica, aparece «FACTURA ELECTRÓNICA».' },
          { label: 'Número', description: 'Solo en comprobantes no electrónicos: completás la numeración.' },
          { label: 'Cliente', description: 'Por defecto «Consumidor Final». Tocá «Cambiar» para elegir otro cliente; «Reset» vuelve a consumidor final.' },
        ],
        paragraphs: ['Arriba a la derecha ves el total de la venta en curso.'],
      },
      {
        title: 'Paso 3 — Agregar productos',
        intro: 'Buscá por código o nombre en «Buscar producto». Al elegir uno se agrega a la lista.',
        bullets: [
          'Cantidad — modificá cuántas unidades vendés.',
          'Precio — editable si tenés permiso; si no, viene de la lista de precios.',
          'Promociones — debajo de cada línea podés elegir promociones disponibles.',
          'Productos de regalo — aparecen marcados y no se pueden quitar manualmente.',
          'x — quita una línea.',
        ],
      },
      {
        title: 'Paso 4 — Promociones y totales',
        bullets: [
          'A la derecha, promociones sobre el total de la factura (si hay).',
          'Neto gravado e IVA — cuando el comprobante discrimina IVA.',
          'Total — importe final a cobrar.',
        ],
      },
      {
        title: 'Paso 5 — Cobrar',
        intro: 'Elegí la forma de pago en el panel derecho (efectivo, tarjeta, etc.) y tocá «Cobrar».',
        bullets: [
          '«Limpiar» — borra la venta en curso para empezar otra.',
          'Si la factura es electrónica, puede pedirse conexión con AFIP antes de confirmar.',
          'Al terminar bien, la pantalla se limpia para la siguiente venta.',
        ],
      },
      {
        title: 'Cerrar la terminal',
        intro: 'La X arriba a la izquierda cierra la terminal y volvés al menú de Administración.',
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpScreen} */
export const ADM_SALES_TERMINAL_HELP = {
  screenId: 'adm-sales-terminal',
  label: 'Terminal de Ventas',
  navPath: 'Administración → Terminal de Ventas',
  keywords: [
    'terminal', 'punto de venta', 'pos', 'mostrador', 'cobrar', 'venta rápida',
    'consumidor final', 'factura electrónica',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Pantalla de venta rápida para el mostrador. Buscás productos, aplicás promociones y cobrás. Tocá abajo para el paso a paso.',
  sidebarItems: [ADM_SALES_TERMINAL_POS_ITEM],
}
